import { useWindowSize } from '@vueuse/core';

const SMALL_DEVICE_THRESHOLD = 1200;

const { width } = useWindowSize();

export function getIsSmallDevice(): boolean {
  return width.value < SMALL_DEVICE_THRESHOLD;
}
